import * as actionTypes from '../actions/actionTypes';

const initialState = {
  auditLog: {
    auditLog: [],
    count: "",
    isLoading: false,
    isError: false
  },
  auditUserList: {
    auditUserList: [],
    isLoading: false,
    isError: false
  },
  auditLogDetails: [{}],
  isLoading: false,
  isError: false,
}

const auditLogReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_AUDITLOG_LIST:
      return { ...newState, auditLog: { ...newState.auditLog, isLoading: true } };

    case actionTypes.FETCH_AUDITLOG_LIST_SUCCESS:
      return { ...newState, auditLog: { auditLog: [...action.payload.data], count: action.payload.totalCount, status: action.payload.status, isLoading: false, isError: false } };

    case actionTypes.FETCH_AUDITLOG_LIST_FAILURE:
      return { ...newState, auditLog: {auditLog:{...action.payload}, count: action.payload.totalCount, status: action.payload.status, isLoading: false, isError: true } };

    case actionTypes.FETCH_AUDITUSER_LIST:
      return { ...newState, auditUserList: { ...newState.auditLog, isLoading: true } };

    case actionTypes.FETCH_AUDITUSER_LIST_SUCCESS:
      return { ...newState, auditUserList: { auditUserList: [...action.payload.data], status: action.payload.status, isLoading: false, isError: false } };

    case actionTypes.FETCH_AUDITUSER_LIST_FAILURE:
      return { ...newState, auditUserList: {auditUserList:{...action.payload}, status: action.payload.status, isLoading: false, isError: true } };

      default:
      return { ...newState };
  }
};


export default auditLogReducer;